module.exports = __webpack_public_path__ + "static/design03-077e58037cb19f06d40b0455c967f975.jpg";